import { Record } from 'immutable';
import { schema } from 'normalizr';

export const WarrantyStatus = new Record({
  id: undefined,
  name: undefined,
  obsolete: false,
});

export const warrantyStatusSchema = new schema.Entity('warrantyStatuses');

// for reading in nested models, object with { field: schema }
// warrantyStatusSchema.define({  });
